<template>
  <div>
    <!-- 下拉选择器 -->
    <template v-if="type === 'select'">
      <el-select
        :style="t.style || { width: '100%' }"
        v-model="data[t.prop]"
        :placeholder="t.placeholder || '请选择'"
        @change="selectChange"
        clearable
        v-bind="t.props"
        v-on="t.listeners"
      >
        <el-option
          v-for="item in options"
          :key="item.dictTypeId"
          :label="item.dictTypeName"
          :value="item.dictTypeId"
          v-on="t.listeners"
        >
        </el-option>
      </el-select>
    </template>
    <!-- 下拉选择器 -->

    <!-- checkbox复选框 -->
    <template v-else-if="type === 'checkbox'">
      <el-checkbox-group v-model="data[t.prop]" @change="changeCheckBox">
        <el-checkbox
          v-for="item in cities"
          :label="item.value"
          :key="item.value"
          v-on="t.listeners"
          v-bind="t.props"
          >{{ item.label }}</el-checkbox
        >
      </el-checkbox-group>
    </template>
    <!-- checkbox复选框 -->

    <!-- redio 单选组 -->
    <template v-else-if="type === 'radio'">
      <el-radio-group
        v-model="data[t.prop]"
        v-on="t.listeners"
        @change="selectRedio"
        v-bind="t.props"
      >
        <el-radio
          v-for="item in options"
          :label="item.value"
          :key="item.value"
          >{{ item.label }}</el-radio
        >
      </el-radio-group>
    </template>
    <!-- redio 单选组 -->

    <!-- 计数器 -->
    <template v-else-if="type === 'number'">
      <el-input-number
        v-model="data[t.prop]"
        :controls-position="t.position"
        v-on="t.listeners"
        v-bind="t.props"
        @change="handleChange"
      ></el-input-number>
    </template>
    <!-- 计数器 -->

    <!-- cascader级联选择器 -->
    <template v-else-if="type === 'cascader'">
      <el-cascader
        style="width: 100%"
        :options="options"
        v-model="data[t.prop]"
        clearable
        :placeholder="t.placeholder || '请选择'"
        :show-all-levels="t.isStrue"
        :filterable="t.filterable"
        :props="{ checkStrictly: t.checkStrictly }"
        :disabled="t.disabled"
        :size="t.size"
        v-on="t.listeners"
        @change="cascaderChange"
      ></el-cascader>
    </template>
    <!-- cascader级联选择器 -->

    <!-- rate -->
    <template v-else-if="type === 'rate'">
      <el-rate
        v-bind="t.props"
        v-model="data[t.prop]"
        :show-text="t.text"
        v-on="t.listeners"
        @change="rateChange"
      ></el-rate>
    </template>
    <!-- rate -->

    <template v-else-if="type === 'upload'">
      <UploadBtn
        :accept="t.accept"
        v-model="data[t.prop]"
        :listType="t.listType"
        :isShowbtn="t.isShowbtn"
        :showTips="t.showTips"
        :btnTxt="t.btnTxt"
        :showUploadBtn="t.showUploadBtn"
        :limit="t.limit"
        :disabled="t.disabled"
        :fileType="t.fileType"
        :url="t.url"
        :fileTypeSubName="t.fileTypeSubName"
      />
    </template>


    <!-- datetimerange -->
    <template v-else-if="type === 'datetimerange'">
      <el-date-picker
        v-model="data[t.prop]"
        :type="t.type ? t.type : 'daterange'"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :value-format="t.format ? t.format : 'yyyy-MM-dd'"
        v-bind="t.props"
        style="width: 100%"
        clearable
      >
      </el-date-picker>
    </template>
    <!-- datetimerange -->


  </div>
</template>

<script>

import UploadBtn from "@/components/UploadBtn/index.vue";
export default {
  // 具体参数  一切参考 element 组件库
  components: { UploadBtn },
  name: "generalModel",
  props: {
    type: String,
    //form
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //item
    modelData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      options: [],
      //checkBox
      isIndeterminate: false,
      checkAll: false,
      cities: [],
      editorOption: {
        placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], //加粗，斜体，下划线，删除线

            ["clean"], //清除字体样式
            // ["image"] //上传图片、上传视频
          ],
        },
        theme: "snow",
      },
    };
  },
  computed: {
    //返回的item
    t() {
      return this.modelData;
    },
  },
  created() {},
  mounted() {
    // 下拉框
    if (this.t.options) {
      var type = Object.prototype.toString
        .call(this.t.options)
        .replace(/\[object\s|\]/g, "");
      if (type == "Array") {
        this.options = this.t.options;
        this.cities = this.t.options;
      } else {
        this.t.options.then((res) => {
          this.options = res;
          this.cities = res;
        });
      }
    }
  },
  watch: {},
  methods: {
    /**
     * 下拉框选择触发
     */
    selectChange(val) {
      this.$emit("changes", val, val.dictValue);
    },
    /**
     * checkBox 选择
     */
    changeCheckBox(val) {
      // let checkedCount = val.length;
      // this.checkAll = checkedCount === this.cities.length;
      // this.isIndeterminate =
      //   checkedCount > 0 && checkedCount < this.cities.length;
      this.$emit("changes", val);
    },
    /**
     * selectRedio 单选 选择触发
     */
    selectRedio(val) {
      this.$emit("changes", val);
    },
    //计数器
    handleChange(val) {
      this.$emit("changes", val);
    },
    //casder级联选择器
    cascaderChange(val) {
      this.$emit("changes", val);
    },
    //rate
    rateChange(val) {
      this.$emit("changes", val);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ql-snow {
  padding: 0 !important;
  height: 50px !important;
}
</style>
